<template>
	<div
		class="ms-pagination"
		:class="[isPagingTotalV2 ? 'ms-pagination-v2' : '']"
		:style="customProp && customProp.customCss"
	>
		<!-- ============================================================ -->
		<!-- ROW 1 (36px): Summary values + Xem thông tin — chỉ khi V2   -->
		<!-- ============================================================ -->
		<div
			v-if="
				isPagingTotalV2 && pageButtomValueV2 && pageButtomValueV2.length > 0
			"
			class="ms-pagination-summary-row"
		>
			<div class="pag-value-v2 flex items-center">
				<div class="flex items-center">
					<div
						class="flex items-center pag-value-item"
						:class="[
							customProp && customProp.css ? 'page-button-custom-v2' : '',
							index > 0 ? 'ms-mgl-16px' : '',
						]"
						v-for="(item, index) in pageButtomValueV2"
						:key="item.Id"
					>
						<div
							class="ms-mgr-8px text-v2"
							:ref="`item-${index}`"
							v-tooltip="{ content: item.Tooltip }"
						>
							{{ item.Name }}
						</div>
						<div v-if="IsLoadingTotalAmountPage">
							<div class="loading-total"></div>
						</div>
						<div v-else>
							<div
								class="font-bold"
								v-if="isHideValue && isNeedHidAndShowTotal"
							>
								***
							</div>
							<div
								class="font-bold"
								v-else-if="item.formatType == $ms.enum.FormatType.Text"
							>
								{{ item.Value }}
							</div>
							<div class="font-bold" v-else>
								{{ item.Value | formatNumber({ maxDigits: 6 }) }}
							</div>
							<div
								class="font-bold"
								v-if="item.isScreenMall"
								v-tooltip="{ content: item.Value }"
							>
								...
							</div>
						</div>
					</div>
				</div>

				<!-- Xem thông tin / Ẩn thông tin — khi không có selection -->
				<div
					v-if="isNeedHidAndShowTotal && !hasSelectedItemsFromGrid"
					class="text-link ms-mgl-24px"
					@click="showPageButtomValueV2"
				>
					{{
						isHideValue
							? $t('i18nCommon.ViewInfo')
							: $t('i18nCommon.HiddenInfo')
					}}
				</div>

				<!-- Combobox xem thông tin — khi có selection -->
				<ms-dropdown
					v-if="hasSelectedItemsFromGrid"
					ref="viewInfoDropdown"
					class="view-info-combo ms-mgl-16px"
					:width="200"
					:title="currentSelectedText"
				>
					<template slot="icon">
						<div class="flex-center drop-down-select-item">
							<div class="text-dropdown">{{ currentSelectedText }}</div>
							<!-- <div class="mi-new mi-24 mi-icon-arrow-down-blue-small"></div> -->
						</div>
					</template>
					<ms-dropdown-item
						v-for="(item, index) in viewInfoOptions"
						:key="index"
						@click="onClickViewInfo(item)"
						>{{ item.display }}</ms-dropdown-item
					>
				</ms-dropdown>
			</div>
		</div>

		<!-- ============================================================ -->
		<!-- ROW 2 (48px): Tổng số + Số dòng/trang + Pagination          -->
		<!-- ============================================================ -->
		<div
			class="ms-pagination-bottom-row flex items-center justify-between w-full"
		>
			<!-- Bên trái: Tổng số -->
			<div class="flex items-center">
				<div class="postion-pagination-v2 flex" v-if="isPagingTotalV2">
					<div class="total-info">
						<div
							class="flex total-info-position"
							:class="
								customProp && customProp.css ? 'postion-pagination-custom' : ''
							"
						>
							{{ `${$t('i18nComponent.TotalItemV1')}: ` }}
							<div class="ms-mgl-4px font-bold" v-if="!isLoadingTotalRecord">
								{{ pageTotal }}
							</div>
							<div v-else class="ms-mgl-4px">
								<div class="loading-total"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="postion-pagination flex" v-else>
					<span class="total-info">
						<div
							class="flex total-info-position"
							:class="
								customProp && customProp.css ? 'postion-pagination-custom' : ''
							"
						>
							{{ `${$t('i18nComponent.TotalItemV1')}: ` }}
							<div class="ml-2 font-bold" v-if="!isLoadingTotalRecord">
								{{ pageTotal }}
							</div>
							<div v-else class="ml-2">
								<div class="loading-total"></div>
							</div>
						</div>
					</span>
					<span
						class="ml-16"
						:class="customProp && customProp.css ? 'page-button-custom' : ''"
						v-if="pageButtomValue && pageButtomValue.length > 0"
						v-for="item in pageButtomValue"
						:key="item.Id"
					>
						{{ item.Name }}
						<div v-if="isFormDeclaration" class="font-bold">
							{{ item.Value | formatNumber({ maxDigits: 2 }) }}
						</div>
						<div v-else class="font-bold">
							{{ item.Value | formatNumber({ maxDigits: 6 }) }}
						</div>
						<div v-if="item.isScreenMall" v-tooltip="{ content: item.Value }">
							...
						</div>
					</span>
					<div class="flex ml-8" v-if="pagingTemplate">
						<component
							:is="pagingTemplate.template"
							:data="data"
							v-bind="pagingTemplate.props"
						></component>
					</div>
				</div>
				<slot name="slotLeft"></slot>
			</div>

			<!-- Bên phải: Số dòng/trang + pagination -->
			<div class="flex left-pagination align-center" v-if="hasPageSize">
				<div class="ms-mgr-16px">
					{{ $t('i18nCommon.pagingText') }}
				</div>
				<div class="flex items-center ms-mgr-16px">
					<ms-combobox
						class="page-size hy-32"
						:data="recordInPageStore"
						valueField="value"
						displayField="display"
						v-model="pageSize"
						readonly
						@selected="loadPageIndex(1)"
					></ms-combobox>
				</div>
				<div class="flex items-center ms-mgr-8px">
						<!-- Bỏ dải countFrom - countTo khi có số trang (đúng thiết kế ảnh) -->
						<div v-if="!hasPageNumber">
							<span class="font-bold ms-mgr-4px">{{ countFrom }}</span>
							<span class="font-bold">-</span>
							<span class="font-bold ms-mgl-4px">{{ countTo }}</span>
						</div>
					<div class="flex items-center ms-mgl-24px">
						<div
							@click="firstPage"
							:class="{ disableText: disablePrevPage }"
							class="cursor-pointer unselect"
						>
							<div
								class="mi-new-v2 mi-16 mi-icon-v2-previos-end-page"
								:class="{
									'mi-icon-v2-previos-end-page-disabled': disablePrevPage,
								}"
							></div>
						</div>
						<div
							@click="previousPage"
							:class="{ disableText: disablePrevPage }"
							class="ms-mgl-16px cursor-pointer unselect"
						>
							<div
								class="mi-new-v2 mi-16 mi-icon-v2-previos-page"
								:class="{ 'mi-icon-v2-previos-page-disabled': disablePrevPage }"
							></div>
						</div>
						<!-- Số trang kiểu 1 2 3 ... N (từ pageNumberCollapseThreshold trang rút gọn) — chỉ hiển thị khi bật customProp.hasPageNumber
						     Trang đang trỏ (pageIndex) tô đậm + gạch chân; bấm số trang -> goToPage tải lại dữ liệu -->
						<template v-if="hasPageNumber && totalPages > 0">
							<div class="ms-mgl-16px page-number-list">
								<template v-for="(item, index) in visiblePageNumbers">
									<div
										v-if="item !== '...'"
										:key="index"
										class="page-number-item"
										:class="{ active: item === pageIndex }"
										@click="goToPage(item)"
									>
										{{ item }}
									</div>
									<span v-else :key="`el-${index}`" class="page-number-ellipsis"
										>...</span
									>
								</template>
							</div>
						</template>
						<div
							@click="nextPage"
							:class="{ disableText: disableNextPage }"
							class="ms-mgl-16px cursor-pointer unselect"
						>
							<div
								class="mi-new-v2 mi-16 mi-icon-v2-next-page"
								:class="{
									'mi-icon-v2-next-page-disabled':
										disableNextPage || isLoadingTotalRecord,
								}"
							></div>
						</div>
						<div
							@click="lastPage"
							:class="{ disableText: disableNextPage }"
							class="ms-mgl-16px cursor-pointer unselect"
						>
							<div
								class="mi-new-v2 mi-16 mi-icon-v2-next-end-page"
								:class="{
									'mi-icon-v2-next-end-page-disabled':
										disableNextPage || isLoadingTotalRecord,
								}"
							></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { mapGetters, mapMutations } from 'vuex';
import {} from '@/store/module-const';
import screenResizeMixin from '@/mixins/common/screenResizeMixin.js';

export default {
	name: 'msPagination',
	mixins: [screenResizeMixin],
	props: {
		dataRender: {
			default: 0,
			type: [Number, String],
		},
		hasPageSize: {
			default: true,
			type: Boolean,
		},
		isNeedHidAndShowTotal: {
			default: true,
			type: Boolean,
		},
		/**
		 * Tổng số bản ghi của dữ liệu
		 */
		pageTotal: {
			default: 0,
			type: [Number, String],
		},
		pageIndexCurrent: {
			default: 1,
			type: Number,
		},
		pagingTemplate: {},
		data: {},
		pageButtomValue: {
			type: Array,
			return: () => [],
		},
		pageButtomValueV2: {
			type: Array,
			return: () => [],
		},
		isLoadingTotalRecord: {
			default: false,
			type: Boolean,
		},
		listType: 0,
		customProp: {},
		/**
		 * Số trang tối thiểu để chuyển sang dạng rút gọn 1 2 3 ... N
		 * (ít hơn mức này thì hiển thị hết số trang)
		 */
		pageNumberCollapseThreshold: {
			default: 5,
			type: Number,
		},
		/**
		 * Số số trang liên tiếp tối đa hiển thị trong một cụm ở dạng rút gọn
		 */
		pageClusterSize: {
			default: 3,
			type: Number,
		},
		hasSelectedItemsFromGrid: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		...mapGetters(['IsLoadingTotalAmountPage']),
		/**
		 * Tổng số trang theo pageSize hiện tại của grid
		 */
		totalPages() {
			return Math.ceil(this.pageTotal / this.pageSize);
		},
		disableNextPage() {
			if (this.pageIndex >= this.totalPages && !this.useServerSide) {
				return true;
			}
			return false;
		},
		disablePrevPage() {
			if (this.pageIndex <= 1) {
				return true;
			}
			return false;
		},
		isPagingTotalV2() {
			return this.customProp && this.customProp.isPagingTotalV2;
		},

		/**
		 * Hiển thị số trang kiểu 1 2 3 ... N — mặc định BẬT cho mọi màn hình,
		 * view nào muốn tắt truyền customProp.hasPageNumber = false
		 */
		hasPageNumber() {
			return !this.customProp || this.customProp.hasPageNumber !== false;
		},

		/**
		 * Danh sách số trang hiển thị trong vùng phân trang (dạng rút gọn 1 2 3 ... N):
		 *  - Ít trang (dưới pageNumberCollapseThreshold): hiện hết, không có dấu ...
		 *  - Nhiều trang: trang đầu + cụm pageClusterSize số liên tiếp quanh trang
		 *    hiện tại + trang cuối, ngắt quãng bằng dấu ...
		 * Con trỏ trang hiện tại là pageIndex; bấm số trang (goToPage -> loadPageIndex)
		 * làm pageIndex đổi và computed này tự tính lại theo trang vừa bấm
		 */
		visiblePageNumbers() {
			const me = this;
			const total = me.totalPages;
			if (!me.hasPageNumber || total <= 0) return [];
			if (total < me.pageNumberCollapseThreshold) {
				return me.buildFullPageNumbers(total);
			}
			const start = me.resolveClusterStart(me.pageIndex, total);
			return me.insertEllipsis(me.collectCollapsedPageNumbers(start, total));
		},

		isFormDeclaration() {
			return this.listType == this.$ms.enum.ListType.Declaration;
		},
		isScreenSmall() {
			return this.$ms.commonFunc.checkSmallScreen();
		},

		currentPage() {
			const me = this;
			return me.pageIndex - 1;
		},
		countFrom() {
			const me = this;
			if (me.currentPage == 0) {
				return 1;
			}

			const countFrom =
				me.dataRender == 0 ? 0 : me.currentPage * me.pageSize + 1;
			return countFrom;
		},
		countTo() {
			const me = this;
			if (me.currentPage == 0) {
				return me.pageSize < me.pageTotal ? me.pageSize : me.pageTotal;
			}

			const computed = me.currentPage * me.pageSize + me.dataRender;
			const countTo =
				me.pageTotal > 0 ? Math.min(computed, me.pageTotal) : computed;
			return countTo;
		},

		// BỔ SUNG: Computed properties cho combobox view info
		viewInfoOptions() {
			const me = this;
			return [
				{
					value: me.$ms.enum.ViewInfoType.ViewAll,
					display: me.$t('i18nCommon.ViewAllInvoices'),
				},
				{
					value: me.$ms.enum.ViewInfoType.ViewSelected,
					display: me.$t('i18nCommon.ViewSelectedInvoices'),
				},
			];
		},

		currentSelectedText() {
			const me = this;
			if (
				me.selectedViewOption !== null &&
				me.selectedViewOption !== undefined
			) {
				const found = me.viewInfoOptions.find(
					(item) => item.value === me.selectedViewOption
				);
				if (found) return found.display;
			}
			return me.$t('i18nCommon.ViewInfo');
		},
	},
	data() {
		const me = this;
		return {
			pageSize: me.$ms.commonFunc.getTakePageSize(),
			pageIndex: 1,
			recordInPageStore: [
				{
					value: 20,
					display: '20',
				},
				{
					value: 30,
					display: '30',
				},
				{
					value: 50,
					display: '50',
				},
				{
					value: 100,
					display: '100',
				},
			],
			isHideValue: true,
			// BỔ SUNG: Dữ liệu cho combobox view info
			selectedViewOption: null,
		};
	},
	mounted() {},
	methods: {
		...mapMutations(['updateLoadingTotalAmountPage']),

		resetViewInfoDropdown() {
			const me = this;
			me.selectedViewOption = null;
			if (me.$refs.viewInfoDropdown) {
				me.$refs.viewInfoDropdown.closeDropdownMenu();
			}
		},
		onClickViewInfo(item) {
			const me = this;
			if (!item) return;
			me.selectedViewOption = item.value;
		},
		formatTooltip(value) {
			return this.$options.filters.formatNumber(value, {
				maxDigits: 6,
			});
		},
		setPageSize(pageSize) {
			const me = this;
			me.pageSize = pageSize;
		},
		//Load lại page theo số trang.
		loadPageIndex(index) {
			const me = this;
			if (!index || index <= 0) {
				index = 1;
				me.pageIndex = 1;
			} else {
				me.pageIndex = index;
			}
			let payload = {
				skip: (index - 1) * me.pageSize,
				take: me.pageSize,
			};
			me.$ms.commonFunc.setTakePageSize(me.pageSize);
			me.$emit('loadData', payload);
		},
		nextPage() {
			const me = this;
			if (!me.disableNextPage && !me.isLoadingTotalRecord) {
				me.loadPageIndex(this.pageIndex + 1);
			}
		},
		firstPage() {
			const me = this;
			if (!me.disablePrevPage) {
				me.loadPageIndex(1);
			}
		},
		lastPage() {
			const me = this;
			if (!me.disableNextPage) {
				me.loadPageIndex(me.totalPages);
			}
		},
		previousPage() {
			const me = this;
			if (!me.disablePrevPage) {
				me.loadPageIndex(this.pageIndex - 1);
			}
		},

		/**
		 * Case ít trang (tổng số trang dưới ngưỡng rút gọn): hiện hết số trang
		 * Ví dụ: 4 trang -> [1, 2, 3, 4] — không có dấu ...
		 */
		buildFullPageNumbers(total) {
			const list = [];
			for (let i = 1; i <= total; i++) {
				list.push(i);
			}
			return list;
		},

		/**
		 * Xác định trang bắt đầu của cụm pageClusterSize số liên tiếp chứa trang hiện tại:
		 *  - Trang lẻ bắt đầu cụm (1 2 3, 5 6 7...), trang chẵn nằm giữa cụm (3 4 5, 7 8 9...)
		 *    -> cụm trượt theo cặp trang khi bấm: 1-2 hiện 1 2 3, 3-4 hiện 3 4 5...
		 *  - Nếu trang hiện tại thuộc cụm cuối thì hiển thị cụm cuối, không dịch trái
		 *  - Cụm chưa phải cụm cuối nhưng dính sát trang cuối thì dịch trái 1 số
		 */
		resolveClusterStart(current, total) {
			const me = this;
			const lastClusterStart = total - (me.pageClusterSize - 1);
			if (current >= lastClusterStart) {
				return lastClusterStart;
			}
			let start = current === me.pageClusterSize ? current : current <= 2 ? 1 : current - 1;
			start = Math.min(start, lastClusterStart);
			if (me.shouldShiftClusterLeft(start, total)) {
				start -= 1;
			}
			return start;
		},

		/**
		 * Cụm có dính sát trang cuối không (cách đúng 1 số)? — dính thì hiển thị
		 * sẽ nối thành cụm dài hơn: 1 ... 11 12 13 14 (4 số liên tiếp), cần dịch trái.
		 * Không dịch nếu cụm mới bắt đầu ở trang 2 (start = pageClusterSize + 1)
		 * vì sẽ dính trang 1 thành 1 2 3 4
		 * Ví dụ 14 trang, bấm 11 -> cụm 11 12 13 dính trang 14 nên dịch thành 10 11 12
		 */
		shouldShiftClusterLeft(start, total) {
			const me = this;
			return (
				start + me.pageClusterSize - 1 === total - 1 &&
				start > me.pageClusterSize
			);
		},

		/**
		 * Case rút gọn: gom các trang cần hiển thị = trang đầu 1 + cụm pageClusterSize
		 * số liên tiếp quanh trang hiện tại + trang cuối
		 * Ví dụ 7 trang, cụm 3 4 5 -> [1, 3, 4, 5, 7]
		 */
		collectCollapsedPageNumbers(start, total) {
			const me = this;
			const numbers = [1];
			for (let i = start; i < start + me.pageClusterSize; i++) {
				numbers.push(i);
			}
			numbers.push(total);
			return numbers;
		},

		/**
		 * Chèn dấu ... vào giữa 2 trang cách nhau hơn 1 đơn vị (các trang ở giữa bị ẩn);
		 * dấu ... chỉ là chỉ báo, không phải số trang nên không click được.
		 * Trang bị trùng (cụm chứa trang đầu/cuối) thì chỉ giữ 1 lần.
		 * Ví dụ: [1, 3, 4, 5, 7] -> 1 ... 3 4 5 ... 7
		 *        [1, 12, 13, 14] -> 1 ... 12 13 14
		 */
		insertEllipsis(numbers) {
			if (!numbers) return [];
			const pages = [];
			let prev = 0;
			for (let i = 0; i < numbers.length; i++) {
				const page = numbers[i];
				if (page === prev) continue;
				if (page - prev > 1) pages.push('...');
				pages.push(page);
				prev = page;
			}
			return pages;
		},

		/**
		 * Bấm vào số trang -> cập nhật con trỏ pageIndex và phát loadData để tải lại
		 * dữ liệu của trang đó; visiblePageNumbers tự tính lại theo trang vừa bấm
		 */
		goToPage(page) {
			const me = this;
			if (
				!me.isLoadingTotalRecord &&
				page &&
				page > 0 &&
				page <= me.totalPages &&
				page !== me.pageIndex
			) {
				me.loadPageIndex(page);
			}
		},
		reloadPageSize(pageSize) {
			const me = this;
			if (!pageSize) return;
			me.pageSize = pageSize;
			me.pageIndex = 1;
			let payload = {
				skip: (me.pageIndex - 1) * me.pageSize,
				take: me.pageSize,
			};
			me.$emit('loadData', payload, true);
		},

		/**
		 * pddang Thực hiện show hoặc ẩn thông tin dưới cùng của trang
		 * @param {Boolean} isHideValue
		 */
		showPageButtomValueV2() {
			const me = this;
			if (me.IsLoadingTotalAmountPage) return;
			me.isHideValue = !me.isHideValue;
			me.$emit('showPageButtomValueV2', !me.isHideValue);
		},
	},
	watch: {
		pageIndexCurrent: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.pageIndex = newVal || 1;
			},
		},
		selectedViewOption: {
			handler(newVal) {
				const me = this;
				if (newVal) {
					if (me.isHideValue) {
						me.isHideValue = false;
					}
					me.$emit('viewInfoOptionSelected', newVal);
				}
			},
		},
		hasSelectedItemsFromGrid(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.resetViewInfoDropdown();
			}
		},
	},
	created() {
		const me = this;
		if (me.isPagingTotalV2) {
			me.updateLoadingTotalAmountPage(false);
		}
		EventBusGlobal.$on(GlobalEventName.LoadPageSizeGrid, me.reloadPageSize);
	},
	beforeDestroy() {
		const me = this;
		EventBusGlobal.$off(GlobalEventName.LoadPageSizeGrid, me.reloadPageSize);
	},
};
</script>
<style scoped lang='scss'>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
</style>
